import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../../lib/paths/abschlussbericht_FULL_Paths.json';
const P = Schema.attributes;

const FoerderZielenAbschlussKreativ: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title='Beitrag zu den angestrebten Förderzielen' description={PLATZHALTER_TEXT} />
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
		</>
	);
};
export default FoerderZielenAbschlussKreativ;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [P.Abschlussbericht_Kreativwirtschaft.schema.attributes.Abschlussbericht_Kreativ_0203033639_chaetzung_Kreativer_Leistung],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucFoerderZielenAbschlussKreativ = () => {
	return concat(formStruc());
};
